<template>
    <div class="c-get-in-touch">
        <div class="c-get-in-touch__content">
            <y-row>
                <y-col
                    md="12"
                    lg="6"
                >
                    <h3 class="mb-4 mt-4">
                        {{ content.title }}
                    </h3>
                    <p class="mt-0 mb-9">
                        {{ content.synopsis }}
                    </p>

                    <div class="c-get-in-touch__content__email">
                        <a :href="`mailto:${content.title2}`">{{ content.title2 }}</a>
                    </div>
                </y-col>
                <y-col
                    md="12"
                    lg="6"
                >
                    <img
                        :src="content.image?.link"
                        :alt="content.title"
                    >
                </y-col>
            </y-row>
        </div>
    </div>
</template>

<script>

    export default {
        name      : 'GetInTouch',
        components: {},
        props     : {
            content: Object,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
